
export default function init(){
   let frames = document.querySelectorAll("[data-embedded-resize] iframe");

   let resize = ()=>{
      frames.forEach(frame => {
         if(!frame.hasAttribute("width") || !frame.hasAttribute("height")) return;

         let width = parseInt(frame.getAttribute("width"));
         let height = parseInt(frame.getAttribute("height"));

         let aspect = width / height;

         let parent = frame.parentElement;
         
         frame.setAttribute("width", parent.offsetWidth);
         frame.setAttribute("height", parent.offsetWidth / aspect);
      });
   };

   window.addEventListener("resize", resize);

   resize();
}